




import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import anime from 'animejs'

@Component
export default class AnimateField extends Vue {
  @Prop() value!: string

  animatedValue = 0

  created() {
    this.$watch(
      () => this.value,
      this.animateNumber('animatedValue'),
      {
        immediate: true
      }
    )
  }

  animateNumber(prop: string) {
    const vm = this

    return (newVal, oldVal) => {
      anime({
        targets: this,
        [prop]: [oldVal, newVal],
        round: 1,
        easing: 'linear',
        duration: 300,
        complete() {
          vm[prop] = newVal
        }
      })
    }
  }
}
